var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 27.0312L1.11516 25.1201L0.25 22.3438L9.625 17.6562L19 22.3438L18.0232 25.1759L9.625 27.0312Z",
    fill: "#1DE8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 40L0.25 35.3125V22.3438L9.625 27.0312L11.9688 30.4808V36.632L9.625 40Z",
    fill: "#00D0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 35.3125L9.625 40V27.0312L19 22.3438V35.3125Z",
    fill: "#00BBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.375 27.0312L19.8652 25.1201L19 22.3438L28.375 17.6562L37.75 22.3438L36.7732 25.1759L28.375 27.0312Z",
    fill: "#B9A2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.375 40L19 35.3125V22.3438L28.375 27.0312L30.7188 30.4808V36.632L28.375 40Z",
    fill: "#865FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 35.3125L28.375 40V27.0312L37.75 22.3438V35.3125Z",
    fill: "#5C27FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.375L10.4902 7.46383L9.625 4.6875L19 0L28.375 4.6875L27.3982 7.51961L19 9.375Z",
    fill: "#7986E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22.3438L9.625 17.6562V4.6875L19 9.375L21.3438 12.7464V18.9757L19 22.3438Z",
    fill: "#6E77E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.375 17.6562L19 22.3438V9.375L28.375 4.6875V17.6562Z",
    fill: "#4C5CE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.f92d6716453648917140d0982c1235c8.svg";
export { ForwardRef as ReactComponent };